import { render, staticRenderFns } from "./StatsCollector.vue?vue&type=template&id=ee136ae6"
import script from "./StatsCollector.vue?vue&type=script&lang=js"
export * from "./StatsCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports